<template>
  <div class="wrapper-product">
    <MenuComponent
      logoUrl="assets/logos/LogoGreen.svg"
      textColor="var(--green)"
      menuIcon="assets/icons/MenuGreen.svg"
      closeIcon="assets/icons/CloseGreen.svg"
    />

    <div class="wrapper-general">
      <p class="title">FOTOGRAFÍA ECOMMERCE</p>
      <p class="subtitle">Haz que tus productos brillen en el mundo digital</p>
      <div class="container">
        <div v-for="(image, index) in images" :key="index">
          <img :src="image.src" :alt="image.alt" class="file" />
        </div>
      </div>
    </div>

    <FooterComponent overlayColor="var(--green)" />
  </div>
</template>

<script>
import MenuComponent from "@/ux/layout/components/MenuComponent.vue";
import FooterComponent from "@/ux/layout/components/FooterComponent.vue";
import { ecommerceGallery } from "@/data/product/ecommerceGallery.js";

export default {
  name: "EcommerceGalleryView",
  components: {
    MenuComponent,
    FooterComponent,
  },

  data() {
    return {
      images: ecommerceGallery,
    };
  },
};
</script>

<style scoped lang="scss">
@import "src/ux/product/styles/productGalleryStyle";
</style>
